module.exports = __webpack_public_path__ + "img/stoneholder-2.efcc3dd.png";